import { useMutation } from 'react-query'
import { UseMutationOptions } from 'react-query/types/react/types'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { ReferenceMediaFile } from 'types'

/**
 * POST /v1/schedules/:schedule_id/reference_image
 * @see V1::Schedules::ReferenceImagesController — requires `topic`, not a content id.
 */
export interface CreateScheduleReferenceImageVariables {
  scheduleId: number
  topic: string
}

export interface CreateScheduleReferenceImageOptions
  extends Omit<UseMutationOptions<ReferenceMediaFile, Error, CreateScheduleReferenceImageVariables>, 'mutationFn'> {}

export const createScheduleReferenceImage = async (scheduleId: number, topic: string) => {
  const response = await sendToApi<ReferenceMediaFile>(`/schedules/${scheduleId}/reference_image`, {
    method: 'POST',
    body: { topic },
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(buildErrorMessage(response.data.errors) || 'Failed to create reference image')
  }

  return response.data
}

export const useCreateScheduleReferenceImage = (options?: CreateScheduleReferenceImageOptions) => {
  return useMutation<ReferenceMediaFile, Error, CreateScheduleReferenceImageVariables>(
    async ({ scheduleId, topic }) => createScheduleReferenceImage(scheduleId, topic),
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        options?.onSuccess?.(data, variables, context)
      },
    },
  )
}
